import * as actionTypes from "../../src/constants/actionTypes"

export const changeActiveLangAction = (lang) => dispatch => {
    dispatch(changeLang(lang))
}
const changeLang = (payload) => ({
    type: actionTypes.CHANGE_LANG,
    payload
});